import { useTranslation } from "react-i18next";

export const StarRatingIcon = ({
  numberOfStars,
  text,
  alignTextAboveStars,
  color,
  textSize = 15,
  iconSize = 22,
  percentage,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {alignTextAboveStars ? (
        <>
          <div>
            <span style={{ color: color, fontSize: textSize }}>{text}</span>
            <div className="icon-line">
              <i
                className={numberOfStars > 0 ? "fas fa-star" : "far fa-star"}
                style={{ color: color, fontSize: iconSize }}
              />
              <i
                className={numberOfStars > 1 ? "fas fa-star" : "far fa-star"}
                style={{ color: color, fontSize: iconSize }}
              />
              <i
                className={numberOfStars > 2 ? "fas fa-star" : "far fa-star"}
                style={{ color: color, fontSize: iconSize }}
              />
            </div>
            <span style={{ color: color, fontSize: textSize }}>
              {percentage >= 0
                ? percentage < 1
                  ? `< 1% ${t("of contaminants")}`
                  : `${Math.round(percentage)}% ${t("of contaminants")}`
                : percentage
                  ? "-"
                  : ""}
            </span>
          </div>
        </>
      ) : (
        <div className="icon-line">
          <i
            className={numberOfStars > 0 ? "fas fa-star" : "far fa-star"}
            style={{ color: color, fontSize: iconSize }}
          />
          <i
            className={numberOfStars > 1 ? "fas fa-star" : "far fa-star"}
            style={{ color: color, fontSize: iconSize }}
          />
          <i
            className={numberOfStars > 2 ? "fas fa-star" : "far fa-star"}
            style={{ color: color, fontSize: iconSize }}
          />
          <span style={{ color: color, marginLeft: 6, fontSize: textSize }}>
            {text} -{" "}
            {percentage >= 0
              ? percentage < 1
                ? `< 1% ${t("of contaminants")}`
                : `${Math.round(percentage)}% ${t("of contaminants")}`
              : percentage
                ? "-"
                : ""}
          </span>
        </div>
      )}
    </>
  );
};
